export {};
//# sourceMappingURL=SafeArea.types.js.map